import { get as _get } from 'lodash';

export const getLaborDay = (year) => {
    const date = new Date(year, 8, 7)
    return getMonday(date)
}

export const getMemorialDay = (year) => {
    const date = new Date(year, 4, 31)
    return getMonday(date)
}

// gets last monday that occurred before or on day of given date
const getMonday = (date) => {
    const day = date.getDay(),
        diff = date.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
    return new Date(date.setDate(diff));
}

// need to check for these: 

// SET DATES
// - New Years Eve 
// - New Years Day
// - Fourth of July
// - Christmas Eve
// - Christmas Day

//  BASED ON DAY OF THE WEEK
// - Mother’s Day -- second Sunday of May
// - Memorial Day -- last monday in May
// - Father’s Day -- 3rd sunday in June
// - Labor Day -- first mon in Sept
// - Thanksgiving -- 4th thursday in Nov

// USE LIBRARY
// - Passover
// - Rosh Hashanah
// - Easter


// Maps 0-indexed month + day of month to holiday
const holidayDateMapping = {
    0: { 1: "New Years Day" },
    6: { 4: "July 4th"},
    11: { 
        24: "Christmas Eve",
        25: "Christmas",
        31: "New Years Eve"
     }
}

// Month, Day of Week, Occurance
const weekdayOfMonthHolidayMapping = {
    4: {
        0: { 2: "Mother's Day" },
        1: { '-1': "Memorial Day" }
    },
    5: {
        0: { 3: "Father's Day" }
    },
    8: {
        1: { 1: "Labor Day" }
    },
    10: {
        4: { 4: "Thanksgiving" }
    }
}

const sameDayOfYear = (d1, d2) => d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate()
/*
 * Takes Date object and returns name of holiday 
 * on that day if one exists, or null
*/
export const holidaysOnDate = (date) => {
    let holidays = []

    // check for fixed date holidays
    const fixedHoliday = _get(holidayDateMapping, [date.getMonth(), date.getDate()])
    if (fixedHoliday) {
        holidays.push(fixedHoliday)
    }

    const daysInMonth = new Date(2023, date.getMonth() + 1, 0).getDate()

    // how many times has this day of week occurred in the current month? (-1 if last occurence in month)
    let occurrence = daysInMonth - date.getDate() < 7 ? -1 : Math.ceil(date.getDate() / 7) 

    const holiday = _get(weekdayOfMonthHolidayMapping, [date.getMonth(), date.getDay(), occurrence])
    if (holiday) {
        holidays.push(holiday)
    }

    // check for easter
    let easterDate = getEaster(date.getFullYear())
    if (easterDate.getMonth() === date.getMonth() && easterDate.getDate() === date.getDate()) {
        holidays.push("Easter")
    }

    // check for jewish holidays
    let passoverStart = getPassover(date.getFullYear())
    if (sameDayOfYear(date, addDays(passoverStart, -1))) {
        holidays.push("First night of Passover (Starts at Sundown)")
    }

    if (date > passoverStart && date < addDays(passoverStart, 1)) {
        holidays.push("Passover")
    }

    let roshHashanahStart = getRoshHashanah(date.getFullYear())
    if (sameDayOfYear(date, addDays(roshHashanahStart, -1))) {
        holidays.push("First night of Rosh Hashanah (Starts at Sundown)")
    }

    if (date > roshHashanahStart && date < addDays(roshHashanahStart, 1)) {
        holidays.push("Rosh Hashanah")
    }

    const yomKippur = addDays(roshHashanahStart, 8)

    if (sameDayOfYear(date, yomKippur)) {
        holidays.push("First night of Yom Kippur (Starts at Sundown)")
    }
    if (sameDayOfYear(date, addDays(yomKippur, 1))) {
        holidays.push("Yom Kippur")
    }

    return holidays.length > 0 ? holidays.join(", ") : null
}

// Easter + Jewish Holidays Calculation Reference: https://quasar.as.utexas.edu/BillInfo/ReligiousCalendars.html

// not exactly the same as % operator
const remainder = (x, y) => x - (y * Math.floor(x / y))

const calcG = (year) => {
    return remainder(year,19) + 1
}

const calcC = (year) => {
    let h = +`${year}`.slice(0, -2)
    return Math.floor(h/4) + Math.floor(8 * (h + 11)/ 25) - h
}

const calcS = (year) => {
    const g = calcG(year)
    const c = calcC(year)
    return remainder(11 * g + c, 30)
}

const addDays = (date, days) => {
    const dateCopy = new Date(date)
    dateCopy.setDate(dateCopy.getDate() + days)
    return dateCopy
}

const paschalFullMoon = (year) => {
    const s = calcS(year)
    let date = new Date(year, 3, 19)
    return addDays(date, -s)
}

const getEaster = (year) => {
   let date = paschalFullMoon(year) 
   let daysUntillSunday = 7 - date.getDay() 
   return addDays(date, daysUntillSunday)
}

const getRoshHashanah = (year) => {
    const g = calcG(year)

    let rem = remainder(12 * g, 19)
    let num = 
        (765433 * rem * 4 * 98496) + 
        (remainder(year,4) * 492480 * 98496) -
        ((313 * year + 89081) * 4 * 492480)

    const denom = 492480 * 4 * 98496

    let wholeNum = Math.floor(num / denom)
    num = num % denom

    let dayOfSept = (Math.floor(year/100) - Math.floor(year/400) - 2) + wholeNum +
        num / denom

    let date = new Date(year, 8, Math.floor(dayOfSept))
    let dayOfWeek = date.getDay()
    let plusDays = 0
    switch(dayOfWeek) {
        case 0:
        case 3:
        case 5:
            plusDays = 1
            break;
        case 1:
            if ((25920 * num > 23269 * denom) && (rem > 11)) {
                plusDays = 1
            }
            break;
        case 2:
            if((2160 * num > 1367 * denom) && (rem > 6)) {
                plusDays = 2
            }
            break;
        default:
    }
    
    return addDays(date, plusDays)
}

const getPassover = (year) => {
    let date = getRoshHashanah(year)
    let M = date.getDate()
    if (date.getMonth() === 9) {
        M += 30
    }
    return new Date(year, 2, 21 + M)
}


// WEBPACK FOOTER //
// ./src/helpers/holidays.js